import { supabase } from '../supabase'
import { ServiceError } from '../errors/service-error'

export type HostGatewayFeeClaim = {
  rentalId: string
  status: 'notice_period' | 'disputed' | 'approved' | 'applied' | 'waived'
  actualCostCents: number
  grossFeeCents: number
  processorCreditCents: number
  appliedCents: number
  statementReference: string
  disputeUntil: string
}

const claimStatuses = new Set<HostGatewayFeeClaim['status']>([
  'notice_period',
  'disputed',
  'approved',
  'applied',
  'waived',
])

function parseClaim(value: unknown): HostGatewayFeeClaim | null {
  if (value === null) return null
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    throw new Error('Invalid processor claim response')
  }
  const row = value as Record<string, unknown>
  if (
    typeof row.rentalId !== 'string' ||
    !claimStatuses.has(row.status as HostGatewayFeeClaim['status']) ||
    typeof row.actualCostCents !== 'number' ||
    typeof row.grossFeeCents !== 'number' ||
    typeof row.processorCreditCents !== 'number' ||
    typeof row.appliedCents !== 'number' ||
    typeof row.statementReference !== 'string' ||
    typeof row.disputeUntil !== 'string'
  ) {
    throw new Error('Incomplete processor claim response')
  }
  return row as HostGatewayFeeClaim
}

export async function getHostGatewayFeeClaim(
  rentalId: string,
): Promise<HostGatewayFeeClaim | null> {
  const { data, error } = await supabase.rpc('my_host_gateway_fee_claim', {
    p_rental_id: rentalId,
  })
  if (error) throw ServiceError.fromSupabaseError(error)
  return parseClaim(data)
}

export async function disputeHostGatewayFee(rentalId: string, reason: string): Promise<void> {
  const { data, error } = await supabase.rpc('dispute_host_gateway_fee', {
    p_rental_id: rentalId,
    p_reason: reason.trim(),
  })
  if (error) throw ServiceError.fromSupabaseError(error)
  if (data !== true) throw new Error('Processor claim dispute was not recorded')
}
